import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'sdc-suppliers',
  templateUrl: './suppliers.component.html',
  styleUrls: ['./suppliers.component.css']
})
export class SuppliersComponent {
  constructor(private router: Router) {}

  navigateTo(route: string): void {
    this.router.navigate(['/supplier', route]);
  }
}